<template>
  <div
    v-if="!hide"
    class="cookie-bar"
  >
    <div class="container">
      <p>
        {{ message }}
        <a :href="linkUrl" target="_blank">
          {{ linkText }}
        </a>
      </p>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        @click="onClick"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  @Component
  export default class CookieBar extends Vue {
    @Prop(String) message;
    @Prop(String) linkText;
    @Prop(String) linkUrl;
    @Prop(String) buttonText;
    hide = true;

    created() {
      this.hide = !!localStorage.getItem('cookie-bar.hide')
    }

    onClick() {
      localStorage.setItem('cookie-bar.hide', '1');
      this.hide = true;
    }
  }
</script>
